import { z } from 'zod';

export const birthDateValidation = z.coerce
  .date({
    errorMap: (issue) => {
      switch (issue.code) {
        case 'invalid_type':
          return { message: 'A data de nascimento é obrigatória' };
        case 'invalid_date':
          return { message: 'Formato da data é inválido' };
        default:
          return { message: 'Verifique este campo' };
      }
    },
  })
  .refine(
    (value) => {
      const valueDate = new Date(value);
      const now = new Date();

      return now.getTime() - valueDate.getTime() >= 568025136000;
    },
    { message: 'Você deve ser maior de 18 anos para se cadastrar.' },
  );
